import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'ConjunctionSelect';

const classes = {
  bgHover: `${PREFIX}-bgHover`
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.bgHover}`]: {
    '&:hover': {
      background: theme.palette.primary.light
    }
  }
}));

const ConjunctionSelect = (props: any) => {
  const { disabled, conjunctionOptions, setConjunction, selectedConjunction } = props;
  const conjsCount = Object.keys(conjunctionOptions).length;
  const [selectedValue, setSelectedValue] = React.useState(selectedConjunction);

  const onChangeHandler = (event: any) => {
    setConjunction(event.target.value);
    setSelectedValue(event.target.value);
  };

  return (
    <StyledFormControl variant="outlined">
      <Select
        className={disabled ? '' : classes.bgHover}
        disabled={disabled}
        value={selectedValue}
        id="conjuction"
        onChange={onChangeHandler}
      >
        {conjsCount > 0 &&
          Object.entries(conjunctionOptions).map((obj: any) => (
            <MenuItem key={obj[1].id} value={obj[1].key}>
              {obj[1].key}
            </MenuItem>
          ))}
      </Select>
    </StyledFormControl>
  );
};

export default ConjunctionSelect;
